// store/userSlice.js
import { createSlice, nanoid } from '@reduxjs/toolkit';

const initialState =  [
  {
    id: 1,
    full_name: 'Ajil Joseph',
    username: 'ajilj',
    email: 'ajil@example.com',
    phone_number: '+91-9876543210',
    gender: 'Male',
    date_of_birth: '1998-05-20',
    address: 'Kochi, Kerala',
    user_role: 'admin',
  },
  {
    id: 2,
    full_name: 'Sneha Ramesh',
    username: 'sneha_r',
    email: 'sneha@example.com',
    phone_number: '+91-9123456780',
    gender: 'Female',
    date_of_birth: '1995-11-02',
    address: 'Mumbai, Maharashtra',
    user_role: 'user',
  },
  {
    id: 3,
    full_name: 'Rahul Mehra',
    username: 'rahulm',
    email: 'rahul@example.com',
    phone_number: '+91-9812345678',
    gender: 'Male',
    date_of_birth: '1990-01-15',
    address: 'Delhi, India',
    user_role: 'moderator',
  },
  {
    id: 4,
    full_name: 'Priya Sharma',
    username: 'priyash',
    email: 'priya@example.com',
    phone_number: '+91-9087654321',
    gender: 'Female',
    date_of_birth: '1994-07-12',
    address: 'Bangalore, Karnataka',
    user_role: 'user',
  },
  {
    id: 5,
    full_name: 'Amit Kumar',
    username: 'amitk',
    email: 'amit@example.com',
    phone_number: '+91-9988776655',
    gender: 'Male',
    date_of_birth: '1988-09-09',
    address: 'Patna, Bihar',
    user_role: 'admin',
  },
  {
    id: 6,
    full_name: 'Divya Nair',
    username: 'divyanair',
    email: 'divya@example.com',
    phone_number: '+91-9445566778',
    gender: 'Female',
    date_of_birth: '1996-03-25',
    address: 'Thiruvananthapuram, Kerala',
    user_role: 'user',
  },
  {
    id: 7,
    full_name: 'Karan Singh',
    username: 'karansingh',
    email: 'karan@example.com',
    phone_number: '+91-9333344455',
    gender: 'Male',
    date_of_birth: '1993-12-01',
    address: 'Chandigarh, India',
    user_role: 'moderator',
  },
  {
    id: 8,
    full_name: 'Neha Patel',
    username: 'nehapatel',
    email: 'neha@example.com',
    phone_number: '+91-9221122334',
    gender: 'Female',
    date_of_birth: '1992-06-18',
    address: 'Ahmedabad, Gujarat',
    user_role: 'user',
  },
  {
    id: 9,
    full_name: 'Manoj Das',
    username: 'manojd',
    email: 'manoj@example.com',
    phone_number: '+91-9000111222',
    gender: 'Male',
    date_of_birth: '1991-04-04',
    address: 'Kolkata, West Bengal',
    user_role: 'user',
  },
  {
    id: 10,
    full_name: 'Anjali Menon',
    username: 'anjalim',
    email: 'anjali@example.com',
    phone_number: '+91-9556677889',
    gender: 'Female',
    date_of_birth: '1997-10-30',
    address: 'Chennai, Tamil Nadu',
    user_role: 'admin',
  },
];
;

const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    addUser: {
      reducer(state, action) {
        state.push(action.payload);
      },
      prepare(user) {
        return {
          payload: {
            id: nanoid(),
            ...user,
          },
        };
      },
    },
    updateUser(state, action) {
      const { id, ...updates } = action.payload;
      const existing = state.find(u => u.id === id);
      if (existing) {
        Object.assign(existing, updates);
      }
    },
    deleteUser(state, action) {
      return state.filter(u => u.id !== action.payload);
    },
  },
});

export const { addUser, updateUser, deleteUser } = userSlice.actions;
export default userSlice.reducer;
